(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oratide-fit"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__osgFit) return;
    window.__osgFit = true;
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('.osg-fit__btn');
      if (!link) return;
      if (window.OratideSignal && window.OratideSignal.selectQty && window.OratideSignal.selectQty(link.getAttribute('data-osg-qty'))) {
        event.preventDefault();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oratide-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__osgHeader) return;
    window.__osgHeader = true;
    function measure() {
      var hd = document.querySelector('[data-osg-hd]');
      if (!hd) return;
      var h = hd.offsetHeight;
      document.documentElement.style.setProperty('--osg-hd-h', h + 'px');
      document.body.style.setProperty('--header-height', h + 'px');
      document.body.style.setProperty('--header-group-height', h + 'px');
    }
    function onScroll() {
      var hd = document.querySelector('[data-osg-hd]');
      if (hd) hd.classList.toggle('is-stuck', window.scrollY > 8);
    }
    document.addEventListener('click', function (event) {
      var t = event.target;
      if (!t.closest) return;
      var open = t.closest('[data-osg-menu-open]');
      if (open) {
        var dlg = document.getElementById(open.getAttribute('aria-controls'));
        if (dlg && dlg.showModal) { dlg.showModal(); open.setAttribute('aria-expanded', 'true'); }
        return;
      }
      if (t.closest('[data-osg-menu-close]') || (t.matches && t.matches('dialog[data-osg-menu]'))) {
        var d = t.closest('dialog[data-osg-menu]');
        if (d) d.close();
      }
    });
    document.addEventListener('close', function (event) {
      if (!event.target.matches || !event.target.matches('dialog[data-osg-menu]')) return;
      var btn = document.querySelector('[aria-controls="' + event.target.id + '"]');
      if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus({ preventScroll: true }); }
    }, true);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { measure(); onScroll(); });
    else { measure(); onScroll(); }
    document.addEventListener('shopify:section:load', function () { measure(); onScroll(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oratide-hero"] && !Shopify.designMode) return;
  try {
    
  /**
   * Measures the headline and sets the exact size that fits the column.
   *
   * The Liquid estimate in the section body is a character-count guess at a budget
   * wide enough for any fallback serif, so it always lands small. This corrects it
   * to the real face.
   *
   * The measurement is of the text itself, via a Range — NOT the span's box. The
   * spans are display:block, so their box width is always the column width and
   * measuring it would return the same number at every font size.
   *
   * width / fontSize is scale-invariant, so it is valid to measure at whatever size
   * the headline currently happens to be, including a clamped one.
   */
  (function () {
    const MIN = 20; // px, matches the clamp() floor (1.25rem)
    const MAX = 52; // px, matches the clamp() ceiling (3.25rem)
    const SAFE = 0.995; // a sub-pixel margin, so rounding cannot produce an overflow

    const lastWidth = new WeakMap();

    function fit(col) {
      const heading = col.querySelector('.ohero__h');
      const lines = col.querySelectorAll('.ohero__line');
      if (!heading || !lines.length) return;

      const available = col.clientWidth;
      if (!available) return;

      const current = parseFloat(getComputedStyle(heading).fontSize);
      if (!current) return;

      const range = document.createRange();
      let widest = 0;
      for (const line of lines) {
        range.selectNodeContents(line);
        const width = range.getBoundingClientRect().width;
        if (width > widest) widest = width;
      }
      if (!widest) return;

      const ems = widest / current;
      const size = Math.min(MAX, Math.max(MIN, (available * SAFE) / ems));
      col.style.setProperty('--o-fs', size.toFixed(2) + 'px');
      lastWidth.set(col, available);
    }

    function fitAll() {
      document.querySelectorAll('.ohero__col').forEach(fit);
    }

    /**
     * Setting the font size does not change the column's width — the column is sized
     * by the flex row and a max-width — so this cannot feed back on itself. The width
     * check is belt and braces in case that ever stops being true.
     */
    const observer =
      'ResizeObserver' in window
        ? new ResizeObserver(function (entries) {
            for (const entry of entries) {
              const col = entry.target;
              if (lastWidth.get(col) !== col.clientWidth) fit(col);
            }
          })
        : null;

    function watchAll() {
      if (!observer) return;
      document.querySelectorAll('.ohero__col').forEach(function (col) {
        observer.observe(col);
      });
    }

    function run() {
      fitAll();
      watchAll();
      // Re-measure once the real face has loaded. Until then the measurement is of
      // whatever fallback the browser swapped in, which is a different width.
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run, { once: true });
    } else {
      run();
    }

    // The theme editor replaces the section's markup in place on every change.
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oratide-signal-buybox"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__osgBuy2) return;
    window.__osgBuy2 = true;
    function price(form) {
      var out = form.querySelector('[data-osg-price]');
      if (!out) return;
      var sub = form.querySelector('[data-osg-bmode][value="sub"]');
      if (sub && sub.checked) {
        var sel = form.querySelector('select[name="selling_plan"]');
        var opt = sel && sel.options[sel.selectedIndex];
        if (opt) out.textContent = opt.getAttribute('data-price');
        return;
      }
      var id = form.querySelector('input[name="id"][data-osg-once-input]:checked');
      if (id) out.textContent = id.getAttribute('data-price');
    }
    function mode(form) {
      var sub = form.querySelector('[data-osg-bmode][value="sub"]');
      if (!sub) return;
      var isSub = sub.checked;
      form.setAttribute('data-mode', isSub ? 'sub' : 'once');
      form.querySelectorAll('[data-osg-sub-input]').forEach(function (i) { i.disabled = !isSub; });
      form.querySelectorAll('[data-osg-once-input]').forEach(function (i) { i.disabled = isSub; });
      if (!isSub && !form.querySelector('[data-osg-once-input]:checked')) {
        var first = form.querySelector('[data-osg-once-input]');
        if (first) first.checked = true;
      }
      price(form);
    }
    document.addEventListener('change', function (event) {
      var t = event.target;
      var form = t.closest && t.closest('[data-osg-buy]');
      if (!form) return;
      if (t.matches('[data-osg-bmode]')) mode(form); else price(form);
    });
    document.addEventListener('click', function (event) {
      var thumb = event.target.closest && event.target.closest('.osg-buy__thumb');
      if (!thumb) return;
      var gallery = thumb.closest('[data-osg-gallery]');
      var main = gallery && gallery.querySelector('.osg-buy__img');
      if (main) { main.removeAttribute('srcset'); main.src = thumb.getAttribute('data-osg-src'); }
      gallery.querySelectorAll('.osg-buy__thumb').forEach(function (t) { t.classList.toggle('is-on', t === thumb); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oratide-signal-check"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__osgCheck) return;
    window.__osgCheck = true;
    function state(card) { if (!card.__osg) card.__osg = { answers: [], step: 0 }; return card.__osg; }
    function show(card, step) {
      var st = state(card);
      var qs = card.querySelectorAll('.osg-check__q');
      var total = qs.length;
      st.step = step;
      qs.forEach(function (q, i) { q.hidden = i !== step; });
      card.querySelector('[data-result]').hidden = step < total;
      var bar = card.querySelector('.osg-check__bar span');
      if (bar) bar.style.width = Math.round((Math.min(step + 1, total) / total) * 100) + '%';
      var back = card.querySelector('[data-back]');
      if (back) back.hidden = step === 0 || step >= total;
      if (step < total) {
        var picked = st.answers[step];
        qs[step].querySelectorAll('.osg-check__opt').forEach(function (b) { b.classList.toggle('is-picked', String(picked) === b.getAttribute('data-v')); });
      }
    }
    function finish(card) {
      var st = state(card);
      var score = st.answers.reduce(function (a, b) { return a + b; }, 0);
      var max = card.querySelectorAll('.osg-check__q').length * 2;
      var low = parseInt(card.getAttribute('data-low'), 10);
      var mid = parseInt(card.getAttribute('data-mid'), 10);
      var qty = score <= low ? 1 : score <= mid ? 2 : 3;
      var copy = JSON.parse(card.querySelector('[data-r-copy]').textContent)[String(qty)];
      var variants = {};
      try { variants = JSON.parse(card.getAttribute('data-variants')); } catch (e) {}
      card.querySelector('[data-r-label]').textContent = copy.label;
      card.querySelector('[data-r-title]').textContent = copy.title;
      card.querySelector('[data-r-body]').textContent = copy.body;
      var cta = card.querySelector('[data-r-cta]');
      cta.textContent = copy.cta;
      cta.setAttribute('data-qty', String(qty));
      var url = card.getAttribute('data-url');
      if (variants[String(qty)]) url += (url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + variants[String(qty)];
      cta.setAttribute('href', url);
      show(card, card.querySelectorAll('.osg-check__q').length);
      var gauge = card.querySelector('[data-r-gauge]');
      gauge.style.width = '0%';
      requestAnimationFrame(function () { requestAnimationFrame(function () { gauge.style.width = Math.max(8, Math.round((score / max) * 100)) + '%'; }); });
      card.querySelector('[data-result]').focus({ preventScroll: true });
    }
    document.addEventListener('click', function (event) {
      var t = event.target;
      if (!t.closest) return;
      var card = t.closest('[data-osg-check]');
      if (!card) return;
      var st = state(card);
      var opt = t.closest('.osg-check__opt');
      if (opt) {
        st.answers[st.step] = parseInt(opt.getAttribute('data-v'), 10);
        opt.parentElement.querySelectorAll('.osg-check__opt').forEach(function (b) { b.classList.toggle('is-picked', b === opt); });
        var total = card.querySelectorAll('.osg-check__q').length;
        setTimeout(function () {
          if (st.step + 1 >= total) { finish(card); return; }
          show(card, st.step + 1);
          var next = card.querySelectorAll('.osg-check__q')[st.step].querySelector('.osg-check__opt');
          if (next) next.focus({ preventScroll: true });
        }, 220);
        return;
      }
      if (t.closest('[data-back]')) { show(card, Math.max(0, st.step - 1)); return; }
      if (t.closest('[data-restart]')) { st.answers = []; show(card, 0); return; }
      var cta = t.closest('[data-r-cta]');
      if (cta && window.OratideSignal && window.OratideSignal.selectQty) {
        if (window.OratideSignal.selectQty(cta.getAttribute('data-qty'))) event.preventDefault();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oratide-signal-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__osgCta) return;
    window.__osgCta = true;
    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('[data-osg-to-supply]');
      if (!link) return;
      if (window.OratideSignal && window.OratideSignal.scrollToSupply && window.OratideSignal.scrollToSupply()) {
        event.preventDefault();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oratide-signal-noise"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__osgNoise) return;
    window.__osgNoise = true;
    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-osg-noise-btn]');
      if (!button) return;
      var stage = button.closest('[data-osg-noise]');
      if (!stage) return;
      var quiet = !stage.classList.contains('is-quiet');
      stage.classList.toggle('is-quiet', quiet);
      button.setAttribute('aria-pressed', quiet ? 'true' : 'false');
      button.textContent = quiet ? button.getAttribute('data-off') : button.getAttribute('data-on');
      var state = stage.querySelector('[data-osg-state]');
      if (state) state.textContent = state.getAttribute(quiet ? 'data-quiet' : 'data-loud');
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
